import React from "react";
import { connect } from "react-redux";

import { IAppState } from "../../state/Store";
import MessagingToolbar from "./MessagingToolbar";
import MessagingSummary from "./MessagingSummary";

interface MessagingSidebarProps {
    broadcasting: boolean;
    allowBroadcast: boolean;
    allowRegister: boolean;
    broadcast: () => void;
    didSubscribe: () => void;
}

class MessagingSidebar extends React.Component<MessagingSidebarProps> {
    render(): React.ReactNode {
        return (
            !this.props.broadcasting && (
                <div
                    className="message-listing col-pane auto"
                    ng-if="!ctrl.IsBroadcasting">
                    <MessagingToolbar
                        broadcasting={this.props.broadcasting}
                        allowBroadcast={this.props.allowBroadcast}
                        allowRegister={this.props.allowRegister}
                        broadcast={() => this.props.broadcast()}
                        didSubscribe={
                            this.props.didSubscribe
                        }></MessagingToolbar>
                    <MessagingSummary></MessagingSummary>
                </div>
            )
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagingSidebar);
